import CityPageTemplate from "../city-template/CityPageTemplate";
import { sanFranciscoConfig } from "./data";

export default function SanFranciscoPage() {
  return <CityPageTemplate config={sanFranciscoConfig} />;
}